/**
 * Broadcast channel names for inter-tab communication
 * Centralized management of all channel names used in the application
 */
export enum BroadcastChannelNames {
    /**
     * Channel for single instance detection and management
     */
    SINGLE_INSTANCE = "elitphone-single-instance",
}

export enum BroadcastChannelTypes {
    /**
     * Type for instance active
     */
    INSTANCE_ACTIVE = "INSTANCE_ACTIVE",
    /**
     * Type for instance closed
     */
    INSTANCE_CLOSED = "INSTANCE_CLOSED",
}

/**
 * BroadcastChannel event names
 */
export const BroadcastChannelEvents = {
    /**
     * Standard message event for BroadcastChannel communication
     */
    MESSAGE: "message",
} as const;
